import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getQuickSubscription } from 'reducers';
import { getBypassedSubscription } from 'reducers';
import { getSprintSubscription } from 'reducers';


import { find as findQuickSubscription } from './quick/actions';
import { find as findBypassedSubscription } from './bypassed/actions';
import { find as findSprintSubscription } from './sprint/actions';

const subscriptionDecorator = (DecoratedComponent) => {

  class SubscriptionDecorator extends Component {
    componentDidMount() {
      this.fetchSub();
    }

    componentDidUpdate(oldProps) {
      if (this.props.subId !== oldProps.subId) {
        this.fetchSub();
      }
    }

    fetchSub() {
      const {
        findQuickSubscription,
        findBypassedSubscription,
        findSprintSubscription,
        quickSubId,
        bypassedSubId,
        sprintSubId,
      } = this.props;
      quickSubId && findQuickSubscription(quickSubId);
      bypassedSubId && findBypassedSubscription(bypassedSubId);
      sprintSubId && findSprintSubscription(sprintSubId);
    }

    render() {
      const { children, findBypassedSubscription, findSprintSubscription, findQuickSubscription, ...props } = this.props;

      return React.createElement(
        DecoratedComponent,
        props,
        children
      );
    }
  }

  const mapStateToProps = (state, { quickSubId, bypassedSubId, sprintSubId }) => {
    let getSub;
    if (bypassedSubId) {
      getSub = getBypassedSubscription;
    } else if (quickSubId) {
      getSub = getQuickSubscription;
    } else if (sprintSubId) {
      getSub = getSprintSubscription;
    } else {
      getSub = () => {
        // TODO: add error notification or collection data metrics
        console.log('SubID does not pass');
      }
    }

    const subId = bypassedSubId || quickSubId || sprintSubId;

    return {
      subId,
      subscription: getSub(state, subId),
    }
  }

  const mapDispatchToProps = {
    findQuickSubscription,
    findBypassedSubscription,
    findSprintSubscription,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(SubscriptionDecorator);
}

export default subscriptionDecorator;
